"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[122,1938],{

/***/ 99435:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ layout_YDSHeader; }
});

;// CONCATENATED MODULE: ../../node_modules/@swc/helpers/src/_extends.mjs
function extends_() {
  extends_ = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return extends_.apply(this, arguments);
}

function _extends() {
  return extends_.apply(this, arguments);
}

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(26297);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(66383);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/next/router.js
var next_router = __webpack_require__(5632);
// EXTERNAL MODULE: ../../node_modules/react-instantsearch-core/dist/es/connectors/connectAutoComplete.js
var connectAutoComplete = __webpack_require__(46544);
// EXTERNAL MODULE: ../../node_modules/react-instantsearch-core/dist/es/widgets/InstantSearch.js + 6 modules
var InstantSearch = __webpack_require__(30907);
// EXTERNAL MODULE: ../../node_modules/react-instantsearch-core/dist/es/widgets/Configure.js + 1 modules
var Configure = __webpack_require__(93873);
// EXTERNAL MODULE: ../../node_modules/algoliasearch/dist/algoliasearch-lite.umd.js
var algoliasearch_lite_umd = __webpack_require__(66010);
var algoliasearch_lite_umd_default = /*#__PURE__*/__webpack_require__.n(algoliasearch_lite_umd);
// EXTERNAL MODULE: ../../node_modules/use-media/lib/index.js
var lib = __webpack_require__(81145);
// EXTERNAL MODULE: ../../packages/sf-modules/src/index.js + 26 modules
var src = __webpack_require__(37555);
// EXTERNAL MODULE: ../../packages/commerce/src/index.ts + 2 modules
var commerce_src = __webpack_require__(25144);
// EXTERNAL MODULE: ../../packages/commerce/src/CommerceProvider.tsx + 15 modules
var CommerceProvider = __webpack_require__(82148);
// EXTERNAL MODULE: ../../packages/commerce/src/hooks/tracking/useTracker.ts
var useTracker = __webpack_require__(69590);
// EXTERNAL MODULE: ../../packages/commerce/src/graphql/fragments/checkout/CheckoutBasicFields.gql.js
var CheckoutBasicFields_gql = __webpack_require__(49768);
// EXTERNAL MODULE: ../../packages/commerce/src/APIClient.ts + 1 modules
var APIClient = __webpack_require__(33125);
;// CONCATENATED MODULE: ./hooks/useFragment.js

var useFragment = function(id, fragment, fragmentName) {
    var skip = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false;
    var client = (0,APIClient/* useClient */.m8)();
    if (!id || !fragment) return null;
    return skip ? null : client.readFragment({
        id: id,
        fragment: fragment,
        fragmentName: fragmentName
    });
};

// EXTERNAL MODULE: ../../packages/designkit/src/components/webkit/organisms/Header/index.js + 18 modules
var Header = __webpack_require__(23613);
;// CONCATENATED MODULE: ./components/layout/YDSHeader.js

















var searchClient = algoliasearch_lite_umd_default()("02NTD5FD44", "c4d25b355766321daf1bebe5ebd1a1c4");
var HeaderWithSearch = function(_param) {
    var checkoutBase64Id = _param.checkoutBase64Id, withSearch = _param.withSearch, fullHeader = _param.fullHeader, userLoggedIn = _param.userLoggedIn, username = _param.username, submenu = _param.submenu, mobileMenu = _param.mobileMenu, currentCategory = _param.currentCategory, hits = _param.hits, refine = _param.refine, currentRefinement = _param.currentRefinement, userConfigPage = _param.userConfigPage, promoHeader = _param.promoHeader, handleClosePromoHeader = _param.handleClosePromoHeader, otherProps = (0,_object_without_properties/* default */.Z)(_param, [
        "checkoutBase64Id",
        "withSearch",
        "fullHeader",
        "userLoggedIn",
        "username",
        "submenu",
        "mobileMenu",
        "currentCategory",
        "hits",
        "refine",
        "currentRefinement",
        "userConfigPage",
        "promoHeader",
        "handleClosePromoHeader"
    ]);
    var router = (0,next_router.useRouter)();
    var trackEvent = (0,useTracker/* default */.Z)().trackEvent;
    var checkoutBasicInfos = useFragment("Checkout:".concat(checkoutBase64Id), CheckoutBasicFields_gql/* CheckoutBasicFieldsFragment */.a, "CheckoutBasicFields");
    var isMobile = (0,lib/* useMedia */.GS)({
        maxWidth: 767
    });
    var ref = (0,_sliced_to_array/* default */.Z)((0,commerce_src/* useStateEngine */.kG)(), 2), ref1 = ref[0], catalog = ref1.catalog, config = ref1.config, dispatch = ref[1];
    var ref2 = (0,react.useState)({}), sortedHits = ref2[0], setSortedHits = ref2[1];
    var doRefine = (0,react.useCallback)(function(value) {
        if (value === "") setSortedHits({});
        else {
            refine(value);
            trackEvent({
                type: "Product Searched",
                data: {
                    category: "Catalog",
                    label: value
                }
            });
        }
    }, []);
    var handleClickOnProduct = function(product) {
        trackEvent({
            type: "Product Clicked",
            data: {
                rawProduct: product
            }
        });
    };
    (0,react.useEffect)(function() {
        if (hits && currentRefinement && currentRefinement !== "") {
            var parsedSearchResults = [];
            hits.forEach(function(hit) {
                var mainAisle = (0,src/* get_ */.jR)(hit, [
                    "aisles",
                    "lvl0",
                    0
                ]);
                if (!mainAisle) mainAisle = "Otras categor\xedas";
                if (parsedSearchResults[mainAisle] === undefined) parsedSearchResults[mainAisle] = [];
                var parsedHit = src/* dataTransformers.transformProductFromAlgolia */.IZ.transformProductFromAlgolia(hit);
                parsedSearchResults[mainAisle].push(parsedHit);
            });
            // Sort results by category name
            var sortedResults = {};
            Object.keys(parsedSearchResults).sort().forEach(function(sortedKey) {
                sortedResults[sortedKey] = parsedSearchResults[sortedKey];
            });
            setSortedHits(sortedResults);
        }
    }, [
        hits
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Header["default"], (0,_object_spread/* default */.Z)({
        fullHeader: fullHeader,
        userLoggedIn: userLoggedIn,
        username: username,
        submenu: submenu,
        mobileMenu: mobileMenu,
        cartCount: checkoutBasicInfos ? checkoutBasicInfos.quantity : 0,
        // cartTotal={checkoutBasicInfos ? checkoutBasicInfos.totalPrice : null}
        refineResults: doRefine,
        currentCategory: currentCategory,
        searchResults: sortedHits,
        onClickSearch: function(path) {
            return router.push(path);
        },
        isMobile: isMobile,
        catalogSettings: catalog,
        onChangeDeliveryLocation: function() {
            return dispatch({
                type: CommerceProvider/* APP_STATE_TYPES.TOGGLE_MODAL */.ro.TOGGLE_MODAL,
                kind: CommerceProvider/* MODAL_KIND.CHANGE_DELIVERY_LOCATION */.jk.CHANGE_DELIVERY_LOCATION,
                open: true
            });
        },
        promoHeader: promoHeader,
        promoHeaderIsVisible: config.promoHeader.visible,
        onClosePromoHeader: handleClosePromoHeader,
        userConfigPage: userConfigPage,
        onClickOnProduct: handleClickOnProduct
    }, otherProps));
};
var CustomAutocomplete = (0,connectAutoComplete/* default */.Z)(HeaderWithSearch);
var YDSHeader = function(_param) {
    var otherProps = _extends({}, _param);
    var ref = (0,_sliced_to_array/* default */.Z)((0,commerce_src/* useStateEngine */.kG)(), 1), catalog = ref[0].catalog;
    if (!catalog || !catalog.index) return /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderWithSearch, (0,_object_spread/* default */.Z)({
        withSearch: false
    }, otherProps));
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(InstantSearch/* default */.Z, {
        searchClient: searchClient,
        indexName: catalog.index,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Configure/* default */.Z, {
                hitsPerPage: 12
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomAutocomplete, (0,_object_spread/* default */.Z)({
                withSearch: true
            }, otherProps))
        ]
    });
};
/* harmony default export */ var layout_YDSHeader = (/*#__PURE__*/react.memo(YDSHeader));


/***/ })

}]);